import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import HomeContainer from '../../containers/home/HomeContainer';

const Home = () => {
  return (
    <PageTemplate>
      <HomeContainer />
    </PageTemplate>
  );
};

export default Home;
